<template>
    <div class="container">
        <div class="level">
            <div class="level-left">
                <div class="level-item">
                    <p class="heading has-text-weight-bold is-size-5">User Details</p>
                </div>
            </div>
            <div class="level-right">
                <div class="field">
                    <router-link :to="{ name: 'Users' }" active-class="is-active">
                        <button class="button is-info">
                      <span class="icon">
                    <i class="fas fa-long-arrow-alt-left"></i></span>
                            <span>Back To User List {{userId}}</span>
                        </button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "UserDetails",
        data() {
            return {
                userId: this.$route.params.id,
            }
        }
    }
</script>

<style scoped>

</style>
